import "../styles/styles.css";
import "../../src/components/SearchResult/SearchResults.css";
import "../styles/CourseContent.css";

// === Payment Css Files === //
import "../pages/Payments/css/Donation.css";
import "../pages/Payments/css/Payments.css";
import "../pages/Payments/css/ShoppingCart.css";
import "../pages/Payments/css/PaymentPlan.css";
import "../pages/Payments/css/OrderSummary.css";
import "../pages/Payments/compononents/Button/Button.css";
import "../pages/Payments/compononents/CheckBox/CheckBox.css";
import "../pages/Payments/compononents/HorizontalTab/HorizontalTab.css";
import "../pages/Payments/compononents/Modals/Modals.css";
import "../pages/Payments/compononents/PhoneInputField/PhoneField.css";
import "../pages/Payments/compononents/TextArea/TextArea.css";
import "../pages/Payments/compononents/Tooltip/Tooltip.css";
// import '../pages/Payments/compononents/SelectField/SelectField.css';
import "../pages/Payments/compononents/SelectField/SelectField";
import "../pages/Payments/compononents/Datefield/Datefield.css";
import "../pages/Payments/compononents/ShoppingCartListing/ShoppingCartListing.css";
import "../pages/Payments/compononents/QuantityField/QuantityField.css";
import "../pages/Payments/compononents/SideDrawer/Subdrawer.css";
import "../assets/css/ModalVideo/modal-video.css";
// === Payment Css Files === //
import "../components/SideDrawerNew/SideDrawer.css";
import "../components/Inbox/assets/css/ChatRoom.css";

//settings
import "../assets/css/PaymentMethod.css";
import "../assets/css/editprofile.css";

//change phone
//import "../components/Header/Header.css"
import "../assets/css/form.css";
import "../assets/css/RolePermissionDetails.css";

//certificate

import "../components/TaCertificates/CoursesCard/CoursesCards.css";
import "../components/TaCertificates/ShearModalBody/ShearModalBody.css";
import "../components/HorizotalTabs/HrTabsFill.css";

import "../components/SearchBox/Search.css";
import "../components/HorizotalTabs/TableSubHeader.css";

//certificate details
import "../assets/css/certificates.css";

//COMPONENT CSS
import "../components/Table/Table.css";
import "../components/TracksAccordian/TracksAccordian.css";
import "../components/EmptyCard/EmptyCard.css";
import "../components/FileUplaoder/FileUplaoder.css";
import "../components/FileUplaoder/FileUplaoderField.css";
import "../components/Modals/Modals.css";
import "../components/AddTextField/AddTextField.css";
import "../components/Inbox/components/FullLayout/FullLayout.css";
import "../components/Inbox/assets/css/inbox.css";
import "../components/Inbox/components/TextField/TextField.css";
import "../components/SwitchAccordion/SwitchAccordionRoll.css";

import React, { useState, useEffect } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";

import { getUserData, getUserAuthData } from "../hooks/HelperFunctions";
import DraggableDialog from "../hooks/Dialog";
import CustomizedSnackbar from "../hooks/Snackbar";
import SimpleBackdrop from "../components/Backdrop/SimpleBackdrop";
import { StyledEngineProvider } from "@mui/material";

import "../components/PhoneInputField/PhoneField.css";
import { ShoppingCartProvider } from "../contexts/CartContext";

import dynamic from "next/dynamic";

import "../assets/css/FormGroup.css";

import "../components/MediaLibrary/MediaLibrary.css";
import "../components/AlrtMessage/AlertMessageTwo.css";
import "../components/TextField/TextField.css";
import "../assets/css/fonts.css";
import "../components/SlateEditor/SlateEditor.css";
import "../components/VerifyOtp/Header/Header.css";

import "../components/RedioBox/RedioBox.css";

import "../components/CeoMessage/Ceofonts.css";

import { store } from "../redux/store";
import { Provider } from "react-redux";
import Script from "next/script";
import PWAInstallPrompt from "../components/PWAInstallPrompt/PWAInstallPrompt";
import Head from "next/head";

function App({ Component, pageProps: { session, ...pageProps } }) {
  const [updateCart, setUpdateCart] = useState(true);
  const [openSignUpModel, setOpenSignUpModel] = useState(false);

  const [userData, setUserData] = useState([]);
  const [userToken, setUserToken] = useState("");
  const [userAuthenticated, setUserAuthenticated] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogBody, setDialogBody] = useState("");

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // severity can be: success, error, warning, info, success
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [enrollCourse, setEnrollCourse] = useState();

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
    setUserToken(localStorage.getItem("userToken"));
    setUserAuthenticated(
      localStorage.getItem("userAuthenticated")
        ? localStorage.getItem("userAuthenticated")
        : false,
    );
  }, []);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/sw.js")
          .then((registration) => {
            console.log(
              "Service Worker registered with scope:",
              registration.scope,
            );
          })
          .catch((error) => {
            console.log("Service Worker registration failed:", error);
          });
      });
    }
  }, []);

  const showCourseEnrollMessage = (response) => {
    if (response.data.body.status == true) {
      window.location.replace(`my-learning?enrollment=success`);
    } else {
      setSnackbarSeverity("error");
      setSnackbarMessage(response.data.body.message);
      setShowSnackbar(true);
    }
  };

  const enrollNowHandler = (course, authorized = "false") => {
    // console.log(course);
    let isUserAuthenticated = localStorage.getItem("userAuthenticated");
    if (isUserAuthenticated == "true" || authorized == "true") {
      // const instructorName = course?.instructors[0]?.instructorName;
      setEnrollCourse(course);
      // handleOpenDialog("Enroll course for free", `${course.courseTitle} with ${instructorName}`);
      handleOpenDialog(
        "Enroll course for free",
        <div className="ModalDetails">
          <h2>{course?.courseTitle}</h2>
          <p>{course?.leadInstructor}</p>
        </div>,
      );
    } else {
      localStorage.setItem("pendingOperation", "enrollment");
      localStorage.setItem("pendingOperationData", JSON.stringify(course));
      setOpenSignUpModel(true);
    }
  };

  const enrollNowTrackTermHandler = (term, authorized = "false") => {
    console.log(userAuthenticated, authorized, "[lkjl");
    if (userAuthenticated == "true" || authorized == "true") {
      // setEnrollCourse(term);

      handleOpenDialog(
        "Enroll term for free",
        <div className="ModalDetails">
          <h2>{term?.trackTermName}</h2>
        </div>,
      );
    } else {
      localStorage.setItem("pendingOperation", "enrollment");
      localStorage.setItem("pendingOperationType", "track");
      localStorage.setItem("pendingOperationData", JSON.stringify(term));
      setOpenSignUpModel(true);
    }
  };

  const handleOpenDialog = (title, body) => {
    setDialogTitle(title);
    setDialogBody(body);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmCloseDialog = () => {
    const baseUrl =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_API_URL_PROD
        : process.env.NEXT_PUBLIC_API_URL_DEV;

    let token = localStorage.getItem("userToken");
    // Request interceptors for API calls
    axios.interceptors.request.use(
      (config) => {
        config.headers["Authorization"] = `Bearer ${token}`;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );

    const adminPortalURL =
      process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
        ? process.env.NEXT_PUBLIC_PORTAL_URL_PROD
        : process.env.NEXT_PUBLIC_PORTAL_URL_DEV;

    const userData = getUserData();
    const postData = {
      userId: userData.id,
      courseId: enrollCourse.courseId,
      adminPortalURL: adminPortalURL,
    };

    // hide dialog box
    setOpenDialog(false);
    // show loader
    setOpenBackdrop(true);

    axios
      .post(`${baseUrl}/studentPortal/enrollNow`, postData)
      .then((response) => showCourseEnrollMessage(response))
      .catch((err) => {
        console.log(err);
        if (err.response.data.message) {
          setSnackbarSeverity("error");
          setSnackbarMessage(err.response.data.message);
          setShowSnackbar(true);
        }
      });

    return true;
  };

  /**
   * When click on snackbar close btn
   */
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackbar(false);
  };

  const handleCloseBackdrop = () => {
    setOpenBackdrop(false);
  };

  const showSnackbarMessage = (severity, message) => {
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
    setShowSnackbar(true);
  };
  const url = process.env.NEXT_PUBLIC_APP_URL || "https://mytakbir.com";
  return (
    <StyledEngineProvider injectFirst>
      <Head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#000000" />
        <meta
          name="robots"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta
          name="googlebot"
          content={
            process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
              ? "index, follow"
              : "noindex, nofollow"
          }
        />
        <meta name="referrer" content="no-referrer-when-downgrade" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        <title>Takbir - Best online Islamic learning and teaching site</title>
        <meta
          name="description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta
          property="og:site_name"
          content="Takbir - Best online Islamic learning and teaching site "
        />
        <meta
          property="og:description"
          content="Takbir is a secured, simple and easy-to-use online learning platform for learners and teachers of Islam. Learn Islam, Iman, Ihsan, Tazkiya, Akhlaq, Quran, Hadith, Fiqh, Arabic and much more in one place."
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content={url} />
        <meta
          property="og:title"
          content="Takbir - Best online Islamic learning and teaching site"
        />
        <meta
          property="og:image"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />
        <meta
          property="og:image:secure_url"
          content="https://cdn.mytakbir.com/static-assets/meta/web-takbir-img.png"
        />

        <link
          rel="icon"
          href="https://cdn.mytakbir.com/static-assets/meta/takbir-lms-learning-management-system-muslim-favicon.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon.ico" />
        {/* <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" /> */}

        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-7XY3WGDSHE"
        ></script>

        <script
          id="google-analytics"
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){window.dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-7XY3WGDSHE');
            `,
          }}
        />

        <script
          id="mixpanel"
          dangerouslySetInnerHTML={{
            __html: `
              (function(e,c){if(!c.__SV){var l,h;window.mixpanel=c;c._i=[];c.init=function(q,r,f){function t(d,a){var g=a.split(".");2==g.length&&(d=d[g[0]],a=g[1]);d[a]=function(){d.push([a].concat(Array.prototype.slice.call(arguments,0)))}}var b=c;"undefined"!==typeof f?b=c[f]=[]:f="mixpanel";b.people=b.people||[];b.toString=function(d){var a="mixpanel";"mixpanel"!==f&&(a+="."+f);d||(a+=" (stub)");return a};b.people.toString=function(){return b.toString(1)+".people (stub)"};l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders start_session_recording stop_session_recording people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
              for(h=0;h<l.length;h++)t(b,l[h]);var n="set set_once union unset remove delete".split(" ");b.get_group=function(){function d(p){a[p]=function(){b.push([g,[p].concat(Array.prototype.slice.call(arguments,0))])}}for(var a={},g=["get_group"].concat(Array.prototype.slice.call(arguments,0)),m=0;m<n.length;m++)d(n[m]);return a};c._i.push([q,r,f])};c.__SV=1.2;var k=e.createElement("script");k.type="text/javascript";k.async=!0;k.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\\/\\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";e=e.getElementsByTagName("script")[0];e.parentNode.insertBefore(k,e)}})(document,window.mixpanel||[]);
              mixpanel.init('60e7a8f3c95c4e2b186ace1f2dc5aa09', {autocapture: true, record_sessions_percent: 100});
            `,
          }}
        />
      </Head>

      <PWAInstallPrompt />
      <SimpleBackdrop open={openBackdrop} handleClose={handleCloseBackdrop} />
      <DraggableDialog
        openDialog={openDialog}
        title={dialogTitle}
        titlePadding="10px 0px"
        body={dialogBody}
        actionButtonMargin="0px"
        actionButton="Yes, Enroll Me!"
        handleCloseDialog={handleCloseDialog}
        handleConfirmCloseDialog={handleConfirmCloseDialog}
        // width="500px"
        width="100%"
        padding="0px"
        //Height="200px"
      />
      <CustomizedSnackbar
        open={showSnackbar}
        severity={snackbarSeverity}
        message={snackbarMessage}
        handleClose={handleSnackbarClose}
      />

      <Provider store={store}>
        <ShoppingCartProvider>
          <Component
            {...pageProps}
            updateCart={updateCart}
            setUpdateCart={setUpdateCart}
            enrollNowHandler={enrollNowHandler}
            enrollNowTrackTermHandler={enrollNowTrackTermHandler}
            openSignUpModel={openSignUpModel}
            setOpenSignUpModel={setOpenSignUpModel}
            showSnackbarMessage={showSnackbarMessage}
            setOpenBackdrop={setOpenBackdrop}
          />
        </ShoppingCartProvider>
      </Provider>
    </StyledEngineProvider>
  );
}

export default dynamic(() => Promise.resolve(App), { ssr: false });
